import React, { Component } from 'react';
import Apng from 'react-apng';
import './style.less';

import loadImg from '../../static/images/load/waitdialog.png';

export default class Load extends Component {
    render(){
        return(
            <div className="load">
                {/* <div className="load_img" ref={com => {this.load = com}}></div> */}
                <Apng 
                    className="load_img"
                    src={loadImg}
                    autoPlay={true}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/template/Load/Load.jsx